let React = require("react");
const {  Link, NavLink  } = require('react-router-dom');

let UserInfo = require("./UserInfo.jsx");

let ApplicationContext = require("../config/ApplicationContext.js");
let Application =        require("../Application.js");

class SiteHeader extends React.Component {

    constructor(){
        super();

        this.onSearch = this.onSearch.bind(this);
        this.logout = this.logout.bind(this);
        this.showMenu = this.showMenu.bind(this);
    }

    logout() {
        googleGA("send", "event", "libraries", "signout");
        Application.dataStore.logoutUser();
    }

    onSearch(event){
        if(event.key === "Enter" && this.props.onSearch){
            this.props.onSearch(this.input.value);
            this.input.value = "";
        }
    }

    showMenu(){
        this.menu.classList.toggle("show");
    }

    componentWillMount(){
        this.urlSignUp = `${ApplicationContext.adskAccountUrl}/register`;
    }

    doAuth(){
        Application.dataStore.doAuth(`${window.location.pathname}`);
        this.props.onSendGoogleGA("home", "signin");
    }

    getDashboardItem() {
        if (!ApplicationContext.getUserData()) return;

        const checkActive = (match, location) => {
            return location.pathname.match(/\/((?!(explore|search)).)*\/(libraries|3dmodels|packages)/);
        };

        return <li className="header-nav__dashboard">
                   <NavLink isActive={checkActive} to="/start" activeClassName="header-nav__is-active">Dashboard</NavLink>
               </li>
    }

    getExploreItem() {
        const checkActive = (match, location) => {
            return location.pathname.startsWith("/explore") || location.pathname.startsWith("/search");
        };

        return <li className="header-nav__dashboard">
                   <NavLink isActive={checkActive} to ="/search?q=" activeClassName="header-nav__is-active">Explore</NavLink>
               </li>
    }

    getExplore(avatarUrl){
        let {baseUrl = "/"} = this.props

        return  <ul className="header-nav -small">
                    <li className="header-nav__logo">
                        <Link to={baseUrl}><img src={ApplicationContext.assetUrlPrefix + "/assets/logo_circuits.svg"} /></Link>
                        <div className="header-nav__hamburger" onClick={this.showMenu}></div>
                    </li>
                    <div className="header-nav__options" ref={div => this.menu = div}>

                        { this.getDashboardItem() }
                        { this.getExploreItem() }

                        <li className="header-nav__new">
                            <NavLink to ="/updates" activeClassName="header-nav__is-active">What's new</NavLink>
                        </li>
                        <li className="header-nav__search">
                            <label htmlFor="generalSearch"></label>
                            <input id="generalSearch" type="text" ref={input => this.input = input} onKeyPress={this.onSearch} placeholder="Search for libraries, components and 3D models"/>
                        </li>
                        <li className="header-nav__links">
                            {ApplicationContext.getUserData()?
                                <UserInfo/>
                                : <div className="header__buttons">
                                    <a className="header__buttons__signIn button" href="#" onClick={this.doAuth} >Sign In</a>
                                    <a className="header__buttons__signUp button" href={this.urlSignUp} onClick={() => this.props.onSendGoogleGA("home", "signUp")} target="_blank" >Sign Up</a>
                                </div>
                            }
                        </li>
                    </div>
                </ul>
    }

    getHome(){
        return  <ul className="header-nav -small">
                    <li className="header-nav__logo">
                        <h1 className="hero__head">AUTODESK <span>LIBRARY.IO</span></h1>
                        <div className="header-nav__hamburger onTop" onClick={this.showMenu}></div>
                    </li>
                    <div className="header-nav__options" ref={div => this.menu = div}>

                        { this.getDashboardItem() }
                        { this.getExploreItem() }

                        <li className="header-nav__new">
                            <Link to ="/updates">What's new</Link>
                        </li>

                        <li className="header-nav__search">
                            <label htmlFor="generalSearch"></label>
                            <input id="generalSearch" type="text" ref={input => this.input = input} onKeyPress={this.onSearch} placeholder="Search for libraries, components and 3D models"/>
                        </li>
                        <li className="header-nav__links">
                            {this.props.children}
                        </li>
                    </div>
                </ul>
    }

    render() {
        let avatarUrl = ApplicationContext.getUserData() ? ApplicationContext.getUserData().avatar : "https://i0.wp.com/circuits.io/assets/circuits-default-gravatar.png?ssl=1";
        let name = this.props.type === "Home" ? "header home": "header";

        return  <header className={name}>
                    <div className="container">
                        {this.props.type === "Home"? this.getHome(): this.getExplore(avatarUrl)}
                    </div>
                </header>
    }
}

module.exports = SiteHeader;
